import { Amplify } from "aws-amplify";

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_APP_AWS_POOL_ID,
            userPoolClientId: import.meta.env.VITE_APP_AWS_APP_CLIENT_ID,
            identityPoolId: import.meta.env.VITE_APP_AWS_IDENTITY_POOL_ID,
            allowGuestAccess: false
        }
    },
    API: {
        REST: {
            ntab: {
                endpoint: import.meta.env.VITE_API_URL,
                region: import.meta.env.VITE_AWS_REGION
            }
        }
    }
});